import React from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";
import SidebarContent from "./SidebarContent";

// Main Sidebar Component
const Sidebar: React.FC = () => {
  const bg = useColorModeValue("primary.500", "primary.800"); // Adapts to theme mode

  return (
    <Box display={{ base: "none", md: "flex" }}>
      <Box
        w={{ base: "270px", "2xl": "300px" }}
        maxW={{ md: "320px", lg: "340px" }}
        bgColor={bg}
        transition="background-color 0.2s ease"
        // px={2}
        // py={4}
      >
        <SidebarContent />
      </Box>
    </Box>
  );
};

export default Sidebar;
